import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle, ArrowRight, MapPin } from "lucide-react";

export default function OutstandingNotes({ jobPath }) {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/field/outstanding-notes").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  const go = (jobId) => navigate(jobPath ? jobPath(jobId) : `/jobs/${jobId}`);

  return (
    <div data-testid="outstanding-notes" className="bg-amber-50 border border-amber-300 rounded-2xl p-5 shadow-sm">
      <div className="flex items-center gap-2 mb-1">
        <AlertTriangle className="w-5 h-5 text-amber-600" />
        <h3 className="font-heading font-semibold text-amber-800">Jobs to complete</h3>
      </div>
      <p className="text-sm text-amber-700 mb-4">These jobs were re-opened by the office and still need to be completed on-site (times, photos, materials, notes &amp; signature). Please finish them <b>before payroll</b> — your pay for that week is on hold until done.</p>
      <div className="space-y-3">
        {items.map((it) => (
          <button
            key={it.job_id}
            data-testid={`outstanding-job-${it.job_id}`}
            onClick={() => go(it.job_id)}
            className="w-full text-left bg-white rounded-xl border border-amber-200 p-4 hover:border-amber-400 hover:shadow-md transition-all flex items-center justify-between gap-3"
          >
            <div className="min-w-0">
              <p className="font-medium text-navy truncate">{it.customer_name || "Job"} <span className="text-slate-400 font-normal">· {it.job_number}</span></p>
              {it.site_address && <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5 truncate"><MapPin className="w-3.5 h-3.5 shrink-0" />{it.site_address}</p>}
              {it.visit_date && <p className="text-xs text-amber-600 font-medium mt-0.5">Re-opened for {it.visit_date}</p>}
            </div>
            <span className="shrink-0 inline-flex items-center gap-1 text-sm font-semibold text-white bg-amber-600 hover:bg-amber-700 rounded-lg px-3 py-2">
              Complete now <ArrowRight className="w-4 h-4" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
